import custPopover from '@/components/cust_components/cust_popover_component.vue'
import headerComponent from '@/components/cust_components/cust_header_component.vue';
import Vue from 'vue'
import VueCryptojs from 'vue-cryptojs'
import LoaderPopover from '@/components/loaderpopover_component.vue';
 
Vue.use(VueCryptojs)

export default {
    name: 'login',
    components:{
        headerComponent,
        custPopover,
        LoaderPopover,
    
    },
    data(){
        return {
            mobile_view : false,
            passwordFieldType: 'password',
            cust_email:'',
            email_validation:'',
            password:'',
            password_validation:'',
            all_validations_passed:true,
            pwd_img : 'password_close_icon.svg',
            block_customer_popup : false,
            cust_details : {},
            popup_mobile : '',
            isClicked : false,
            service_details : '',
            start_time_exist:'',
            
            
        }
    },
    mounted(){
        if(this.$session.get('cust_details') &&  !this.$session.get('preview_booking_flag'))
        {
            this.$router.push('/mybookings');
        }
        this.responsive_view();
        window.addEventListener('resize', this.responsive_view);
    },
    methods:{
        async responsive_view(){

            await this.$store.commit('responsive_view', window.innerWidth)
           
        },
        close_block_customer_popup(){
            this.block_customer_popup = false;
            this.$session.remove('service_obj')
            this.$router.push('/mybookings');

        },

        signup(){
            this.$router.push('/custsignup')
        },
       
        switchVisibility() {
            
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
            this.pwd_img =   this.passwordFieldType === 'password' ? 'password_close_icon.svg' : 'password_show_icon.svg';
        },
        check_email_validation(){

            this.email_validation = ''; 
            if(this.cust_email.length == 0){
                this.all_validations_passed = false
                this.email_validation = 'Please enter valid email'
            }
    
            else if(!this.$store.state.regx.test(this.cust_email)) {  
                this.all_validations_passed = false
                this.email_validation = 'Invalid email address' 
                
            }
           
        },
        password_validation_check(){
            this.password= this.password.trim();
            this.password_validation = ''
            if(this.password.length == 0){
                this.all_validations_passed = false
                this.password_validation = 'Please enter valid password'
            }
        },
        validation_check(){
            this.all_validations_passed = true;
            this.check_email_validation();
            this.password_validation_check();
        },
        async checkBlockCustomer(){
          
            let store_details = JSON.parse(this.$session.get('store_details'));
            this.popup_mobile = store_details.store_mobile;
            await this.$store.dispatch('checkBlockCustomer',[this.$store.state.api,this.cust_email,store_details.store_id]);
            if(this.$store.state.block_customer_data.length>0){
                let banned_data = {
                
                    "owner_cust_id" : this.$store.state.block_customer_data[0].cust_id,
                    "pay_fullpayment" : this.$store.state.block_customer_data[0].pay_fullpayment,
                    "cust_banned" :  this.$store.state.block_customer_data[0].is_banned
                
                }
                this.$session.set('cust_banned_data', JSON.stringify(banned_data));   
            }

        },
        async BannedCust(){
            this.$store.state.loader_popup = false;
            if(this.$session.get('store_details'))
            {  
                await this.checkBlockCustomer();

                if(this.$session.get('cust_banned_data'))
                {
 
                    let banned_data = JSON.parse(this.$session.get('cust_banned_data'));

                    if(banned_data.cust_banned == 1){
                        this.block_customer_popup = true; 
                    }
                    else if(this.service_details && this.start_time_exist && (banned_data.cust_banned == 0 )){
                        this.$router.push('/terms');  
                    } 
                    else if(this.service_details && !this.start_time_exist && (banned_data.cust_banned == 0 )){
                        this.$router.push('/cart');  
                    } 
                    else{
                        this.$router.push('/mybookings');
                    }   
                }else{
                    if(this.service_details && this.start_time_exist ){
                        this.$router.push('/terms');  
                    } 
                    else if(this.service_details && !this.start_time_exist){
                        this.$router.push('/cart');  
                    } 
                    else{
                        this.$router.push('/mybookings');
                    }  
                }           
            }
            else{
                this.$router.push('/mybookings');
            }  
            
        },
        async submit(){
            this.validation_check();
            if(this.all_validations_passed){
                this.$store.state.loader_popup = true;
                this.isClicked = true;
                var ciphertext = this.CryptoJS.AES.encrypt(this.password,this.Constants.CRYPTO_KEY).toString();
                try{
                    await  this.$store.dispatch('custLogin',[this.$store.state.api,this.cust_email,ciphertext])
                    let  customer_details =  this.$store.state.cust_login_data;
                    this.$session.set('cust_details', JSON.stringify(customer_details));
                    this.isClicked = false;
                   
                    if(this.$session.get('service_obj')){
                        this.service_details = JSON.parse(this.$session.get('service_obj'));
                    }
                    if(this.$session.get('service_obj') && JSON.parse(this.$session.get('service_obj')).length > 0){
                       this.start_time_exist =  this.service_details.every(serv_obj => Object.keys(serv_obj).includes('slot_start_time'))
                    
                    }
                    await  this.BannedCust();
                }
                catch(e)
                {
                    this.$store.state.loader_popup = false;
                    this.password_validation = "Username/Password Incorrect";
                }

            }

        },

    }
}